import VueJustifiedLayout from './JustifiedLayout'

export { VueJustifiedLayout }

export default function install(Vue) {
  Vue.component('VueJustifiedLayout', VueJustifiedLayout)
}
